import React, { useContext } from "react";
import { useAppStore } from "../../../../../context/store";
import { Dialog, Portal, CloseButton, Button, VStack, Text } from "@chakra-ui/react";

import Type from "../../../../../utilies/Types";
import { getProjects } from "../../../../../utilies/services/project/GetProject";
import { serviceCreateOrEditProjects } from "../../../../../api/services/project";
import { showToast } from "../../../../../utilies/Utility";

const DeleteProjectDialog = () => {
  // state
  const showDeleteProjectDialog = useAppStore((s) => s.showDeleteProjectDialog);
  const userData = useAppStore((s) => s.userData);

  // setters
  const setShowDeleteProjectDialog = useAppStore.getState().setShowDeleteProjectDialog;
  const setProjects = useAppStore.getState().setProjects;

  const deleteProject = () => {
    const peoject = showDeleteProjectDialog.data;
    const formData = new FormData();
    formData.append("project_id", peoject.id);
    formData.append("delete", true);

    serviceCreateOrEditProjects(formData, userData.token)
      .then((res) => {
        if (res.data.status == "success") {
          showToast("Project deleted", Type.NOTIFICATION.SUCCESS);
          getProjects({
            userData,
            setProjects,
            onSuccess: () => {},
          });

          setShowDeleteProjectDialog(null);
        } else {
          showToast(res.data.message, Type.NOTIFICATION.WARNING);
        }
      })
      .catch((err) => {
        showToast(err.message, Type.NOTIFICATION.WARNING);
        console.error("Error", err);
      });
  };

  return (
    <Dialog.Root
      lazyMount
      closeOnInteractOutside={false}
      open={showDeleteProjectDialog && showDeleteProjectDialog?.open}
      onOpenChange={(e) => {
        if (!e.open) {
          setShowDeleteProjectDialog(null);
        }
      }}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <VStack gap={0}>
                <Dialog.Title textAlign={"left"} width={"full"}>
                  Confirmation
                </Dialog.Title>
              </VStack>
            </Dialog.Header>

            <Dialog.Body>
              <Text>Do you want delete this project?</Text>
            </Dialog.Body>

            <Dialog.Footer>
              <Dialog.ActionTrigger asChild>
                <Button variant="outline">Cancel</Button>
              </Dialog.ActionTrigger>
              <Button colorPalette={"red"} onClick={deleteProject}>
                Delete
              </Button>
            </Dialog.Footer>
            <Dialog.CloseTrigger asChild>
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default DeleteProjectDialog;
